// A cancellable polling loop for work that finishes on the server.
export function poller(task, delay = 2500) {
  let timer = null;
  let stopped = false;
  const tick = async () => {
    if (stopped) return;
    let again = false;
    try {
      again = await task();
    } catch (error) {
      again = true;
    }
    if (!stopped && again) timer = setTimeout(tick, typeof again === 'number' ? again : delay);
  };
  return {
    start() { stopped = false; clearTimeout(timer); tick(); },
    stop() { stopped = true; clearTimeout(timer); }
  };
}

export const ACTIVE = ['created', 'processing', 'queued', 'waiting', 'running', 'recovering', 'settlement_pending'];

export function active(operation) {
  if (!operation) return false;
  return ACTIVE.indexOf(operation.status) >= 0 || (operation.job_status && ACTIVE.indexOf(operation.job_status) >= 0);
}

export function localDate(value, options) {
  if (!value) return '';
  return new Date(value).toLocaleString(undefined, options || { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function hostOf(url) {
  return String(url || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
}
